export const HELDEN_KEYS_TO_PRODUCT_GROUP = {
  bike_comprehensive_coverage_helden_de: 'bike',
  bike_v2_full_comprehensive_coverage_helden_de: 'bike',
  bike_v2_partial_comprehensive_coverage_helden_de: 'bike',
  commercial_drone_helden_de: 'drone',
  dji_drone_helden_de: 'drone',
  dog_liability_helden_de: 'dog_liability',
  drone_comprehensive_coverage_helden_de: 'drone',
  drone_liability_helden_de: 'drone',
  ebike_v2_full_comprehensive_coverage_helden_de: 'bike',
  ebike_v2_partial_comprehensive_coverage_helden_de: 'bike',
  horse_liability_helden_de: 'horse_liability',
  household_premium_helden_de: 'contents',
  private_liability_helden_de: 'liability',
} as const

export type HeldenProductKey = keyof typeof HELDEN_KEYS_TO_PRODUCT_GROUP
export type HeldenProductGroup = (typeof HELDEN_KEYS_TO_PRODUCT_GROUP)[HeldenProductKey]

export const HELDEN_IMPORTED_PRODUCT_KEYS = Object.keys(
  HELDEN_KEYS_TO_PRODUCT_GROUP
) as HeldenProductKey[]
